// sagas.js
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';

import { fetchLeadStatusFailure, fetchLeadStatusSuccess } from './action';
import { FETCH_LEAD_STATUS_REQUEST } from './actionType';
import { leadStatusApi } from '../../helpers/fakebackend_helper';

function* fetchLeadStatusSaga() {
    try {
        const response = yield call(leadStatusApi);
        if (response.success && response.success === true) {
            const apiResponse = response.data;
            // Transform the data
            const transformedOptions = apiResponse?.map((item) => ({
                id: item?._id,
                label: item?.status,
                value: item?.status,
            }));
            yield put(fetchLeadStatusSuccess(transformedOptions));
        }
    } catch (error) {
        yield put(fetchLeadStatusFailure(error.message));
    }
}

export function* watchleadStatusSaga() {
    yield takeLatest(FETCH_LEAD_STATUS_REQUEST, fetchLeadStatusSaga);
}

function* authFetchStatusSaga() {
    yield all([
        fork(watchleadStatusSaga),
    ]);
}

export default authFetchStatusSaga;